(function () {
  'use strict';

  var STORAGE_KEY = 'inkmerge_recently_viewed_v1';
  var STORAGE_LIMIT = 8;
  var DISPLAY_LIMIT = 4;

  function readJson(element) {
    if (!element) return null;
    try {
      return JSON.parse(element.textContent || 'null');
    } catch (error) {
      return null;
    }
  }

  function safeProductUrl(value) {
    try {
      var url = new URL(String(value || ''), window.location.origin);
      if (url.origin !== window.location.origin || url.pathname.indexOf('/products/') !== 0) return '';
      return url.pathname;
    } catch (error) {
      return '';
    }
  }

  function safeImageUrl(value) {
    if (!value) return '';
    try {
      var url = new URL(String(value), window.location.origin);
      var allowed = url.origin === window.location.origin || url.hostname === 'cdn.shopify.com';
      return allowed && url.protocol === 'https:' ? url.href : '';
    } catch (error) {
      return '';
    }
  }

  function normalizeItem(item) {
    if (!item || typeof item !== 'object') return null;
    var id = String(item.id || '');
    var title = String(item.title || '').trim().slice(0, 160);
    var url = safeProductUrl(item.url);
    var image = safeImageUrl(item.image);
    var alt = String(item.alt || title).trim().slice(0, 180);
    if (!id || !title || !url) return null;
    return { id: id, title: title, url: url, image: image, alt: alt };
  }

  function getSavedItems() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(parsed)) return [];
      return parsed.map(normalizeItem).filter(Boolean);
    } catch (error) {
      return [];
    }
  }

  function setSavedItems(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, STORAGE_LIMIT)));
    } catch (error) {
      // Storage can be unavailable in private or restricted browsing contexts.
    }
  }

  function makeCard(item) {
    var article = document.createElement('article');
    article.className = 'imrv__card';
    article.setAttribute('role', 'listitem');

    var link = document.createElement('a');
    link.className = 'imrv__link';
    link.href = item.url;
    link.setAttribute('data-im-route', 'recently-viewed-product');
    link.setAttribute('aria-label', 'View ' + item.title);

    var media = document.createElement('span');
    media.className = 'imrv__media';
    if (item.image) {
      var image = document.createElement('img');
      image.className = 'imrv__image';
      image.src = item.image;
      image.alt = item.alt;
      image.loading = 'lazy';
      image.decoding = 'async';
      media.appendChild(image);
    }

    var copy = document.createElement('span');
    copy.className = 'imrv__copy';

    var label = document.createElement('span');
    label.textContent = 'Viewed on this device';

    var heading = document.createElement('h3');
    heading.textContent = item.title;

    copy.appendChild(label);
    copy.appendChild(heading);
    link.appendChild(media);
    link.appendChild(copy);
    article.appendChild(link);
    return article;
  }

  function initialize(root) {
    var current = normalizeItem(readJson(root.querySelector('[data-imrv-current]')));
    if (!current) return;

    var saved = getSavedItems();
    var previous = saved.filter(function (item) { return item.id !== current.id; }).slice(0, DISPLAY_LIMIT);
    var grid = root.querySelector('[data-imrv-grid]');

    if (grid && previous.length) {
      previous.forEach(function (item) { grid.appendChild(makeCard(item)); });
      root.hidden = false;
    }

    setSavedItems([current].concat(saved.filter(function (item) { return item.id !== current.id; })));

    var clear = root.querySelector('[data-imrv-clear]');
    if (clear) {
      clear.addEventListener('click', function () {
        try { window.localStorage.removeItem(STORAGE_KEY); } catch (error) {}
        root.hidden = true;
        if (grid) grid.replaceChildren();
      });
    }
  }

  function start() {
    document.querySelectorAll('[data-im-recently-viewed]').forEach(initialize);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
